import Vue from 'vue';
import {request, setAuthInHeader} from "@/api/request";

Vue.prototype.$api = {
    $auth: { // 계정 로그인 / 회원가입 api
        login(params){ // 유저 로그인
            return request.post("member/login", params)
                .then(({data}) => data);
        },
        createMember(params) {
            return request.post("member", params)
                .then(({data}) => data);
        },
        getMember(params) {
            return request.get('member', params)
                .then(({data}) => data);
        },
    },
    $common: {
        getConfigInfo(params) {
            return request.get(`config/info`,params).then(({data}) => data)
        },
        updateConfigInfo(params) {
            return request.post(`config/info/update`,params).then(({data}) => data)
        },
        getFile(params) {
            return request.get(`file`,params).then(({data}) => data)
        },
        updateFile(params) {
            return request.post(`file`,params).then(({data}) => data)
        },
        deleteFile(params) {
            return request.post(`file/delete`,params).then(({data}) => data)
                .then(({data}) => data);
        },

    },
    $member: {
        createProfile(params) {
            return request.post(`profile`, params).then(({data}) => data);
        },
        getProfile(params) {
            return request.get('profile', params)
                .then(({data}) => data);
        },
        updateProfile(params) {
            return request.post(`profile/update`,params).then(({data}) => data)
        },
        deleteProfile(params) {
            return request.post(`profile/delete`,params).then(({data}) => data)
        },
        getMemberList(params) {
            return request.get(`member`,params).then(({data}) => data)
        },
        createMember(params) {
            return request.post(`member`,params).then(({data}) => data)
        },
        updateMember(params) {
            return request.post(`member/update`,params).then(({data}) => data)
        },
        updateSurvey(params) {
            return request.post(`member/eot/update`,params).then(({data}) => data)
        },
        getMemberOutCategory(params) {
            return request.get(`member/out/category`,params).then(({data}) => data)
        },
        deleteMember(params){
            return request.post(`member/delete`,params).then(({data}) => data)
        },
        getMemberLog(params) {
            return request.get(`member/eot/getdata`, params).then(({data}) => data);
        },
        stopMember(params) {
            return request.post(`member/restrict`, params).then(({data}) => data);
        },
        activeMember(params) {
            return request.post(`member/restrict/delete`, params).then(({data}) => data);
        },
        checkIdDouble(params) {
            return request.get("member/chk_id", params).then(({data}) => data);
        },
        checkNickDouble(params) {
            return request.get("member/chk_nick", params).then(({data}) => data);
        },
        getMemberOrderInfo(params) {
            return request.get('member/index/orderer', params).then(({data}) => data);
        },
        updateMemberOrderInfo(params){
            return request.post('member/update/orderer', params).then(({data}) => data);
        },
        getMemberDeliveryInfo(params){
            return request.get('member/delivery', params).then(({data}) => data);
        },
        updateMemberDelivery(params){
            return request.post('member/delivery/update', params).then(({data}) => data);
        },
        deleteMemberDelivery(params){
            return request.post(`member/delivery/delete`,params).then(({data}) => data)
        },
        getDeliveryCategory(params) {
            return request.get('order/category/define', params).then(({data}) => data);
        },
    },
    $board: {
        getQaList(params) {
            return request.get('qa', params).then(({data}) => data);
        },
        getQaCategoryList(params) {
            return request.get('qa/category', params).then(({data}) => data);
        },
        createAnswerQa(params){
            return request.post(`qa/answer`, params).then(({data}) => data);
        },
        updateAnswerQa(params){
            return request.post(`qa/update`, params).then(({data}) => data);
        },
        deleteAnswerQa(params) {
            return request.post(`qa/delete`, params).then(({data}) => data);
        },
        getFaqList(params) {
            return request.get('faq', params).then(({data}) => data);
        },
        createFaq(params){
            return request.post(`faq`, params).then(({data}) => data);
        },
        updateFaq(params){
            return request.post(`faq/update`, params).then(({data}) => data);
        },
        deleteFaq(params) {
            return request.post(`faq/delete`, params).then(({data}) => data);
        },
        getNoticeList(params) {
            return request.get('board/notice', params).then(({data}) => data);
        },
        getNoticeCategoryList(params) {
            return request.get('board/notice/category', params).then(({data}) => data);
        },
        createNotice(params){
            return request.post(`board/notice`, params).then(({data}) => data);
        },
        updateNotice(params){
            return request.post(`board/notice/update`, params).then(({data}) => data);
        },
        deleteNotice(params) {
            return request.post(`board/notice/delete`, params).then(({data}) => data);
        },
    },
    $feed: {
        getFeed(params, bodyData=null) {
            return request.get('feed', params, bodyData).then(({data}) => data);
        },
        updateFeed (params) {
            return request.post(`feed/update`, params).then(({data}) => data);
        },
        deleteFeed (params) {
            return request.post(`feed/delete`, params).then(({data}) => data);
        },
        getFeedComment(params) {
            return request.get('feed/comment', params).then(({data}) => data);
        },
    },
    $today: {
        getToday(params){
            return request.get(`today`, params).then(({data}) => data);
        },
        getTodayCategory(params){
            return request.get(`board/today/category`, params).then(({data}) => data);
        },
        writeTodayCategory(params){
            return request.post(`board/today/category`, params).then(({data}) => data);
        },
        updateTodayCategory(params){
            return request.post(`board/today/category/update`, params).then(({data}) => data);
        },
        deleteTodayCategory(params){
            return request.post(`board/today/category/delete`, params).then(({data}) => data);
        },
        updateToday(params){
            return request.post(`today/update`, params).then(({data}) => data);
        },
        deleteToday(params){
            return request.post(`today/delete`, params).then(({data}) => data);
        },
    },
    $todayBanner: {
        getTodayBanner(params) {
            return request.get(`banner`, params).then(({data}) => data);
        },
        updateTodayBanner(params) {
            return request.post(`banner/update`, params).then(({data}) => data);
        },
        // getBanner(params) {
        //     return request.get(`banner`, params).then(({data}) => data);
        // },
        createTodayBanner(params) {
            return request.post(`banner`, params).then(({data}) => data);
        },
        // updateBanner(params) {
        //     return request.post(`banner/update`, params).then(({data}) => data);
        // },
        deleteBanner(params) {
            return request.post(`banner/delete`, params).then(({data}) => data);
        },
    },
    $magazine: {
        getMagazine(params) {
            return request.get('plan', params).then(({data}) => data);
        },
        getMagazineCategory(params) {
            return request.get('plan/category', params).then(({data}) => data);
        },
        getHash(params) {
            return request.get('plan/hash', params).then(({data}) => data);
        },
        deleteMagazine(params) {
            return request.post(`plan/delete`, params).then(({data}) => data);
        },
        createMagazine(params) {
            return request.post(`plan`, params).then(({data}) => data);
        },
        updateMagazine(params) {
            return request.post(`plan/update`, params).then(({data}) => data);
        },
        getRecommendMagazine(params) {
            return request.get('plan/recommend', params).then(({data}) => data);
        },
        updateRecommendMagazine(params) {
            return request.post(`plan/recommend`, params).then(({data}) => data);
        },
        getAdMagazine(params) {
            return request.get('magagine', params).then(({data}) => data);
        },
        createAdMagazine(params){ // 광고매거진 등록
            return request.post('magagine/create', params).then(({data}) => data);
        },
        updateAdMagazine(params){ // 광고매거진 수정
            return request.post('magagine/update', params).then(({data}) => data);
        },
        deleteAdMagazine(params){ // 광고매거진 삭제
            return request.post('magagine/delete', params).then(({data}) => data);
        },
        getExposureAdMagazine(params){ // 노출 광고매거진
            return request.get('magagine/exposure', params).then(({data}) => data);
        },
        createExposureAdMagazine(params){ // 노출 광고매거진 등록
            return request.post('magagine/exposure/create', params).then(({data}) => data);
        },
        deleteExposureAdMagazine(params){ // 노출 광고매거진 해제
            return request.post('magagine/exposure/delete', params).then(({data}) => data);
        },
        createHash(params) {
            return request.post(`plan/hash`, params).then(({data}) => data);
        },
        updateHash(params) {
            return request.post(`plan/hash/update`, params).then(({data}) => data);
        },
        deleteHash(params) {
            return request.post(`plan/hash/delete`, params).then(({data}) => data);
        },
        createMagazineCategory(params) {
            return request.post(`plan/category`, params).then(({data}) => data);
        },
        updateMagazineCategory(params) {
            return request.post(`plan/category/update`, params).then(({data}) => data);
        },
        deleteMagazineCategory(params) {
            return request.post(`plan/category/delete`, params).then(({data}) => data);
        },
        getTheme(params) {
            return request.get('plan/theme', params).then(({data}) => data);
        },
        createTheme(params) {
            return request.post(`plan/theme`, params).then(({data}) => data);
        },
        updateTheme(params) {
            return request.post(`plan/theme/update`, params).then(({data}) => data);
        },
        deleteTheme(params) {
            return request.post(`plan/theme/delete`, params).then(({data}) => data);
        },
        getBackgroundColor(params) {
            return request.get(`plan/background`, params).then(({data}) => data);
        },
    },
    $item: {
        getItem(params) {
            return request.get('item', params).then(({data}) => data);
        },
        getItemCategory() {
            return request.get(`itemcategory`).then(({data}) => data);
        },
        createItem(params) {
            return request.post('item', params).then(({data}) => data);
        },
        indexingItem(params) {
            return request.post(`itemIndexing`, params).then(({data}) => data);
        },
        updateItem(params) {
            return request.post(`item/update`, params).then(({data}) => data);
        },
        deleteItem(params) {
            return request.post(`item/delete`, params).then(({data}) => data);
        },
        replicaItem(params) {
            return request.post(`item/replica`, params).then(({data}) => data);
        },
        relateItem(params) {
            return request.post(`item/relate`, params).then(({data}) => data);
        },
        getRelateItem(params) {
            return request.get(`item/relate`, params).then(({data}) => data);
        },
        getBrandItem(params){
            return request.get(`item/connect`, params).then(({data}) => data);
        },
        createBrand(params) {
            return request.post('brand/connect', params).then(({data}) => data);
        },
        deleteBrand(params) {
            return request.post(`brand/disconnect`, params).then(({data}) => data);
        },
        createBrandMain(params){
            return request.post('brand/main', params).then(({data}) => data);
        },
        deleteBrandMain(params){
            return request.post('brand/main/delete', params).then(({data}) => data);
        },
        getLinkedBrand(params){
            return request.get(`item/connect`, params).then(({data}) => data);
        },
        getPartCategory(params) {
            return request.get('itemcategory/part', params).then(({data}) => data);
        },
    },
    $declaration: {
        getDeclaration(params){
            return request.get(`board/feed/blind`, params).then(({data}) => data);
        },
        getDeclarationCategory(params) {
            return request.get(`board/feed/blind/category`, params).then(({data}) => data);
        },
        updateDeclaration(params){
            return request.post(`board/feed/blind/update`, params).then(({data}) => data);
        },
        getTodayDeclaration(params){
            return request.get(`board/today/blind`, params).then(({data}) => data);
        },
        updateTodayDeclaration(params){
            return request.post(`board/today/blind/update`, params).then(({data}) => data);
        },
        getUserDeclaration(params){
            return request.get(`member/blind`, params).then(({data}) => data);
        },
        getUserDeclarationCategory(params){
            return request.get(`member/blind/category`, params).then(({data}) => data);
        },
        updateUserDeclaration(params){ // 사용자 신고 상태변경
            return request.post(`member/blind/update`, params).then(({data}) => data);
        },
    },
    $terms: {
        getConfigTerm() {
            return request.get(`config/service`).then(({data}) => data)
        },
        updateConfigTerm(params) {
            return request.post(`config/service/update`,params).then(({data}) => data)
        },
    },
    $custom: {
        getAlarmQa(params) {
            return request.get('qa/unanswered', params).then(({data}) => data);
        },
    },
    $event: {
        getEvent(params) {
            return request.get(`event`, params).then(({data}) => data);
        },
        createEvent(params) {
            return request.post(`event`, params).then(({data}) => data);
        },
        updateEvent(params) {
            return request.post(`event/update`, params).then(({data}) => data);
        },
        deleteEvent(params) {
            return request.post(`event/delete`, params).then(({data}) => data);
        },
    },
    $push: {
        sendPush(params) {
            return request.post(`alram`, params).then(({data}) => data);
        }
    },
    $store:{
        getStoreList(params){
            return request.get(`store`, params).then(({data}) => data);
        },
        createStore(params){
            return request.post(`store`, params).then(({data}) => data);
        },
        deleteStore(params){
            return request.post(`store/delete`, params).then(({data}) => data);
        },
        updateStore(params){
            return request.post(`store/update`, params).then(({data}) => data);
        },
        getMemberStore(params){
            return request.get(`store/member`, params).then(({data}) => data);
        },
        updateMemberStore(params){
            return request.post(`store/member/update`, params).then(({data}) => data);
        },

    },
    $point:{
        getStorePoint(params){
            return request.get(`point/store`, params).then(({data}) => data);
        },
        getStorePointTotal(params){
            return request.get(`point/store/total`, params).then(({data}) => data);
        },
        updateStorePointStatus(params){
            let type = params.type
            delete params.type
            return request.post(`point/store/${type}`, params).then(({data}) => data);
        },
        getPointDefine(params){
            return request.get(`point/define`, params).then(({data}) => data);
        },
        updatePointDefine(params){
            return request.post(`point/define/update`, params).then(({data}) => data);
        },
        getPointList(params){
            return request.get(`point/admin`, params).then(({data}) => data);
        },
        createPoint(params){
            return request.post(`point`, params).then(({data}) => data);

        }
    },
    $file: {
        editorUpload(params) {
            return request.post("file/editorUpload",params)
                .then(({data}) => data);
        },
        downLoad(params){
            return request.get(params)
                .then(({data}) => data);
        },
        updateFile(params) {
            return request.post(`file`, params).then(({data}) => data);
        },
        deleteFile(params) {
            return request.post("file/delete/"+params.a_idx)
                .then(({data}) => data);
        }
    },
    $suggest: {
        getWordList(params) {
            return request.get(`recommand/searchword`, params).then(({data}) => data);
        },
        deleteWord(params) {
            return request.post(`recommand/searchword/delete`, params).then(({data}) => data);
        },
        createSuggestWord(params) {
            return request.post(`recommand/searchword`, params).then(({data}) => data);
        },
        updateSuggestWord(params){
            return request.post(`recommand/searchword/update`, params).then(({data}) => data);
        }
    },
    $style:{
        getStyleList(params) {
            return request.get(`style`, params).then(({data}) => data);
        },
        updateStyle(params){
            return request.post(`style/update`, params).then(({data}) => data);
        },
        getFittingData(params) {
            return request.get('virtual/fitting', params).then(({data}) => data);
        },
        createFittingData(params) {
            return request.post('virtual/fitting', params).then(({data}) => data);
        },
        deleteFittingData(params) {
            return request.post('virtual/fitting/delete', params).then(({data}) => data);
        },
    },
    $lookbook:{
        getLookbook(params) {
            return request.get(`lookbook`, params).then(({data}) => data);
        },
        getLookbookDetail(params) {
            return request.get(`lookbook/detail`, params).then(({data}) => data);
        },
        createLookbook(params) {
            return request.post(`lookbook`, params).then(({data}) => data);
        },
        updateLookbook(params) {
            return request.post(`lookbook/update`, params).then(({data}) => data);
        },
        getLookbookChannel(params) {
            return request.get(`lookbook/channel`, params).then(({data}) => data);
        },
        deleteLookbook(params) {
            return request.post(`lookbook/delete`, params).then(({data}) => data);
        },
        getHash(params) {
            return request.get(`lookbook/hash`, params).then(({data}) => data);
        },
        deleteHash(params) {
            return request.post(`lookbook/hash/delete`, params).then(({data}) => data);
        },
        createHash(params) {
            return request.post(`lookbook/hash`, params).then(({data}) => data);
        },
        updateHash(params) {
            return request.post(`lookbook/hash/update`, params).then(({data}) => data);
        },
        getTheme(params) {
            return request.get(`lookbook/theme`, params).then(({data}) => data);
        },
        deleteTheme(params) {
            return request.post(`lookbook/theme/delete`, params).then(({data}) => data);
        },
        createTheme(params) {
            return request.post(`lookbook/theme`, params).then(({data}) => data);
        },
        updateTheme(params) {
            return request.post(`lookbook/theme/update`, params).then(({data}) => data);
        },
        getChannel(params) {
            return request.get(`lookbook/channel`, params).then(({data}) => data);
        },
        deleteChannel(params) {
            return request.post(`lookbook/channel/delete`, params).then(({data}) => data);
        },
        createChannel(params) {
            return request.post(`lookbook/channel`, params).then(({data}) => data);
        },
        updateChannel(params) {
            return request.post(`lookbook/channel/update`, params).then(({data}) => data);
        },
        getRecommend(params) {
            return request.get(`lookbook/recommend`, params).then(({data}) => data);
        },
        updateRecommend(params) {
            return request.post(`lookbook/recommend`, params).then(({data}) => data);
        },
        createExcel(params) {
            return request.post(`lookbook/excel`, params).then(({data}) => data);
        },
        createExcelItem(params) {
            return request.post(`lookbook/excel/item`, params).then(({data}) => data);
        },
        getLookbookItem(params) {
            return request.get(`lookbook/item`, params).then(({data}) => data);
        },
        writeLookbookItem(params) {
            return request.post(`lookbook/item`, params).then(({data}) => data);
        },
        createExcelMultiItem(params) {
            return request.post(`lookbook/excel/item-multi`, params).then(({data}) => data);
        },
    },
    $order : {
        getOrder(params) {
            return request.get(`order`, params).then(({data}) => data);
        },
        getBankCode(params) {
            return request.get(`order/bank/code`, params).then(({data}) => data);
        },
        updateOrderStatus(params) {
            return request.post(`cart/order/status`, params).then(({data}) => data);
        },
        updateOrder(params) {
            return request.post(`order/update`, params).then(({data}) => data);
        },
        getShippingCosts(params) {
            return request.get(`order/shipping/list`, params).then(({data}) => data);
        },
        updateShippingCosts(params) {
            return request.post(`order/shipping/update`, params).then(({data}) => data);
        },
        updateExpress(params){
            return request.post(`cart/express`, params).then(({data}) => data);
        },
        getOrderByCancel(params) {
            return request.get('cart/status/cancel', params).then(({data}) => data);
        },
        getOrderByTrade(params) {
            return request.get('cart/status/trade', params).then(({data}) => data);
        },
        getOrderByRefund(params) {
            return request.get('cart/status/refund', params).then(({data}) => data);
        },
        updateOrderCart(params) {
            return request.post(`cart/order/update`, params).then(({data}) => data);
        },
        getDeliveryReasonCategory(params) {
            return request.get('order/category/define', params).then(({data}) => data);
        },
    },
    $review : {
        getReview(params) {
            return request.get(`review`, params).then(({data}) => data);
        },
        deleteReview(params) {
            return request.post(`review/delete/admin`, params).then(({data}) => data);
        },
        getReviewMagazine(params) {
            return request.get(`plan/review`, params).then(({data}) => data);
        },
        deleteReviewMagazine(params) {
            return request.post(`plan/review/delete`, params).then(({data}) => data);
        },
        getReviewStyling(params) {
            return request.get(`review/style`, params).then(({data}) => data);
        },
        deleteReviewStyling(params) {
            return request.post(`review/style/delete`, params).then(({data}) => data);
        },
        updateReview(params) {
            return request.post(`review/update`, params).then(({data}) => data);
        },
        setReviewPoint(params) {
            return request.post('review/point', params).then(({data}) => data);
        },
    },
    $brand : {
        getBrandList(params) {
            return request.get(`brand`, params).then(({data}) => data);
        },
        createBrand(params) {
            return request.post(`brand`, params).then(({data}) => data);
        },
        checkBrandName(params){
            return request.get(`brand/chk`, params).then(({data}) => data);
        },
        updateBrand(params) {
            return request.post(`brand/update`, params).then(({data}) => data);
        },
        deleteBrand(params) {
            return request.post(`brand/delete`, params).then(({data}) => data);
        },
        brandDisconnect(params) {
            return request.post(`brand/disconnect`, params).then(({data}) => data);
        },
        brandConnect(params) {
            return request.post(`brand/connect`, params).then(({data}) => data);
        },
        getLookbook(params){
            return request.get(`brand/look_book`, params).then(({data}) => data);
        },
        createLookbook(params) {
            return request.post(`brand/look_book`, params).then(({data}) => data);
        },
        updateLookbook(params) {
            return request.post(`brand/look_book/update`, params).then(({data}) => data);
        },
        deleteLookbook(params) {
            return request.post(`brand/look_book/delete`, params).then(({data}) => data);
        },
        getBrandAd(params) {
            return request.get('advertisement', params).then(({data}) => data);
        },
        createBrandAd(params) {
            return request.post('advertisement', params).then(({data}) => data);
        },
        deleteBrandAd(params) {
            return request.post('advertisement/delete', params).then(({data}) => data);
        },
    },
    $example : {
        getExample(params) {
            return request.get(`examplekeyword`, params).then(({data}) => data);
        },
        writeExample(params) {
            return request.post(`examplekeyword`, params).then(({data}) => data);
        },
        updateExample(params) {
            return request.post(`examplekeyword/update`, params).then(({data}) => data);
        },
        deleteExample(params) {
            return request.post(`examplekeyword/delete`, params).then(({data}) => data);
        },
    },
    $predict : {
        insertImageList(params) {
            return request.purchaseGet(`image_insert`, params).then(({data}) => data);
        },
        getImageList(params) {
            return request.purchaseGet(`image_list`, params).then(({data}) => data);
        },
        insertPriceList(params) {
            return request.purchaseGet(`price_insert`, params).then(({data}) => data);
        },
        getPriceList(params) {
            return request.purchaseGet(`price_list`, params).then(({data}) => data);
        },
    },
    $price : {

    },
    $ai: {
        setItemImageMasking(params) {
            return request.aiPost(`image-masking`, params).then(({data}) => data);
        },
    },
    $handler: {
        authHeader : setAuthInHeader
    }
};

export default Vue.prototype.$api;


